import React from "react";
import { useForm, useFormState } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { Button, Grid, Paper, Typography, Box } from "@mui/material";
import { TaxType } from "@soqs/common";
import BOIndividualDetails from "./BOIndividualDetails";
import { isMobile } from "react-device-detect";
import { Stack } from "@mui/system";

const BOIndividualsList = () => {
  const formstate = useFormState();
  let form = useForm();

  return (
    <Grid size={{ xs: 12 }}>
      <Grid size={{ xs: 12, md: 12 }}>
        {formstate.values?.bo_individuals?.length >= 3 && isMobile ? (
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Typography variant="body1" gutterBottom>
              Should this Trust have more than 3 Individual Beneficiaries,
              please add documentation that could be used to identify them on
              the Suporting Documents Upload page.
            </Typography>
          </Box>
        ) : null}
        <br />
        {formstate.values?.bo_individuals?.length >= 10 ? (
          <Typography variant="body1" gutterBottom>
            Should this Trust have more than 10 Individual Beneficiaries, please
            add documentation that could be used to identify them on the
            Suporting Documents Upload page.
          </Typography>
        ) : null}
        <Stack spacing={2} direction={"row"}>
          <Button
            //sx={{ display: { xs: "none", md: "block" } }}
            name="AddIndividual"
            variant="contained"
            color="primary"
            onClick={() => {
              if (formstate.values?.bo_individuals != null) {
                for (
                  var index = 0;
                  index < formstate.values?.bo_individuals.length;
                  index++
                ) {
                  const arrayCopy = {
                    ...formstate.values?.bo_individuals[index],
                  };

                  var newIndex = formstate.values?.bo_individuals.findIndex(
                    (data) =>
                      data.bo_individual_botype ===
                        arrayCopy.bo_individual_botype &&
                      data.bo_individual_key !== arrayCopy.bo_individual_key
                  );

                  newIndex = newIndex <= 1 ? 0 : newIndex - 1;
                  if (newIndex !== index && !arrayCopy.bo_individual_sorted)
                    form.mutators.move("bo_individuals", index, newIndex);

                  if (!arrayCopy.bo_individual_sorted) {
                    arrayCopy.bo_individual_sorted = true;
                    arrayCopy.bo_individual_collapsed = false;
                    form.mutators.update("bo_individuals", newIndex, arrayCopy);
                  }
                }
              }
              form.mutators.unshift("bo_individuals", {
                bo_individual_key: Date.now().toString(),
                bo_individual_sorted: false,
                bo_individual_collapsed: false,
                bo_individual_botype: 1, //Founder
                bo_individual_idtype: "1", //SA ID
                bo_individual_taxtype: TaxType.PIT,
                bo_individual_country: "ZAF",
                bo_individual_mobilecode: "27",
                bo_individual_passportcountry: "ZAF",
                bo_individual_placeofbirth: "ZAF",
                bo_individual_taxjuristiction: "ZAF",
                bo_individual_passportdt: "2010/01/01",
                bo_individual_unnamed_category: undefined,
                bo_individual_unnamed_description: "",
                bo_individual_unnamed: false,
              });
            }}
            disabled={formstate.values?.bo_individuals?.length >= 10}
          >
            Add Named Beneficial Owner
          </Button>
          <Button
            name="AddUnamedIndividual"
            variant="contained"
            color="primary"
            onClick={() => {
              if (formstate.values?.bo_individuals != null) {
                for (
                  var index = 0;
                  index < formstate.values?.bo_individuals.length;
                  index++
                ) {
                  const arrayCopy = {
                    ...formstate.values?.bo_individuals[index],
                  };

                  var newIndex = formstate.values?.bo_individuals.findIndex(
                    (data) =>
                      data.bo_individual_botype ===
                        arrayCopy.bo_individual_botype &&
                      data.bo_individual_key !== arrayCopy.bo_individual_key
                  );

                  newIndex = newIndex <= 1 ? 0 : newIndex - 1;
                  if (newIndex !== index && !arrayCopy.bo_individual_sorted)
                    form.mutators.move("bo_individuals", index, newIndex);

                  if (!arrayCopy.bo_individual_sorted) {
                    arrayCopy.bo_individual_sorted = true;
                    arrayCopy.bo_individual_collapsed = false;
                    form.mutators.update("bo_individuals", newIndex, arrayCopy);
                  }
                }
              }
              form.mutators.unshift("bo_individuals", {
                bo_individual_key: Date.now().toString(),
                bo_individual_sorted: false,
                bo_individual_collapsed: false,
                bo_individual_unnamed_description: "",
                bo_individual_unnamed: true,
                bo_individual_unnamed_category: undefined,
              });
            }}
            disabled={formstate.values?.bo_individuals?.length >= 10}
          >
            Add Unnamed Beneficial Owner
          </Button>
        </Stack>

        <br />
        <FieldArray name="bo_individuals">
          {({ fields }) =>
            fields.map((data, index) => (
              <div key={fields.value[index].bo_individual_key}>
                <br />
                <Paper
                  variant="outlined"
                  style={{ padding: "2%", paddingTop: "0%" }}
                >
                  <BOIndividualDetails name={data} index={index} />
                  <br />
                  <Button
                    name="deleteindividual"
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      fields.remove(index);
                    }}
                  >
                    Remove Individual
                  </Button>
                </Paper>
              </div>
            ))
          }
        </FieldArray>
      </Grid>
    </Grid>
  );
};

export default BOIndividualsList;
